module.exports = __webpack_public_path__ + "static/illustration_waving-4669c022e7106dcb5a1b3be0ab3df528.svg";